import {
  PaymentTerminal,
  PaymentTerminalDevice,
  PaymentTerminalDeviceV2,
  Printer,
  PrinterDevice,
} from "@lemmonhq/types";
import { printersAPI } from "./printers";
import { terminalsAPI } from "./terminals";
import { getAPIClient } from "../helpers";

export const devicesAPI = {
  getPrinters: async (): Promise<PrinterDevice[]> => {
    const hc = getAPIClient();
    const response = await hc.api.printers.$get();
    if (!response.ok) {
      throw new Error("Failed to fetch printers");
    }
    const list: Printer[] = await response.json();
    return list.map((el) => ({ type: "printer", device: el }));
  },
  getPrintersV2: async (): Promise<PrinterDevice[]> => {
    try {
      const list = await printersAPI.getPrintersV2();
      return list.map((el) => ({ type: "printer", device: el }));
    } catch (error) {
      console.error("Error fetching printers:", error);
      throw error;
    }
  },
  getPaymentTerminalsV2: async (): Promise<PaymentTerminalDeviceV2[]> => {
    try {
      const list = await terminalsAPI.getTerminalsV2();
      return list.map((el) => ({ type: "payment_terminal", device: el }));
    } catch (error) {
      console.error("Error fetching terminals:", error);
      throw error;
    }
  },
  getPaymentTerminals: async (): Promise<PaymentTerminalDevice[]> => {
    const hc = getAPIClient();
    const response = await hc.api.payment_terminals.$get();
    if (!response.ok) {
      throw new Error("Failed to fetch payment_terminals");
    }
    const list: PaymentTerminal[] = await response.json();
    return list.map((el) => ({ type: "payment_terminal", device: el }));
  },
};
